import { NgModule } from '@angular/core';

// Project scope
import { HubClickOutsideDirective } from './click-outside.directive';
import { DomWatchDirective } from './dom-watch.directive';

@NgModule({
  declarations: [
    HubClickOutsideDirective,
    DomWatchDirective
  ],
  exports: [
    HubClickOutsideDirective,
    DomWatchDirective
  ]
})

export class DirectivesModule { }
